import { render, staticRenderFns } from "./HotelAddresses.vue?vue&type=template&id=4df491b2&scoped=true"
import script from "./HotelAddresses.vue?vue&type=script&lang=js"
export * from "./HotelAddresses.vue?vue&type=script&lang=js"
import style0 from "./HotelAddresses.vue?vue&type=style&index=0&id=4df491b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df491b2",
  null
  
)

export default component.exports